import { Suspense } from "react";
import { Route, useParams } from "react-router";
import { AppRouteDefinition } from "../types";

export function createAppRoute(route: AppRouteDefinition<string>) {
  let routeComponent = <RouteComponentWrapper route={route} />;

  if (route.Guard) {
    const guards = Array.isArray(route.Guard) ? route.Guard : [route.Guard];
    for (let idx = guards.length - 1; idx >= 0; idx--) {
      const Guard = guards[idx];
      routeComponent = <Guard>{routeComponent}</Guard>;
    }
  }

  routeComponent = (
    <Route key={route.path} path={route.path} element={routeComponent} />
  );

  return routeComponent;
}

function RouteComponentWrapper(props: { route: AppRouteDefinition<string> }) {
  const params = useParams();

  return (
    <Suspense>
      <props.route.Component params={params} />
    </Suspense>
  );
}
